module.exports = __webpack_public_path__ + "img/step03_01_stand_basic_lebel.30d1f8af.png";